export default {
  ga: {
    trackingId: 'UA-000000-01',
  },
  apolloEngine: {
    key: 'service:sysgears-Apollo-Universal-Starter-Kit:mZvnMtAgDE93vAtk8Cj-1Q', // Set your Apollo Engine key here
  },
};
